// extracted by mini-css-extract-plugin
export const quoteDiv = "quote-module--quoteDiv--F42RY";